import { getConfig } from "@src/config";
import { GQLFinanceType } from "@src/graphql.apollo.generated";
import * as React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import useSearchFilter from "../context/searchfilter/useSearchFilter";
import InfoIcon from "../infoIcon/InfoIcon";
import FormattedCurrency, { formattedCurrencyText } from "../utils/FormattedCurrency";
import * as sc from "./PriceInfo.sc";

interface IPriceInfoProps {
    price: number | null;
    priceInfoText: string;
    alignment?: "left" | "right";
}

const PriceInfo: React.FunctionComponent<IPriceInfoProps> = ({ price, priceInfoText, alignment = "right" }) => {
    const scope = getConfig("scope");
    const intl = useIntl();
    const { filter } = useSearchFilter();

    const ariaLabelFinanceType =
        filter.financeType === GQLFinanceType.credit
            ? intl.formatMessage({
                  id: "leaseme.priceInfo.credit.ariaLabel",
                  defaultMessage: "Kreditrate",
              })
            : intl.formatMessage({
                  id: "leaseme.priceInfo.leasing.ariaLabel",
                  defaultMessage: "Leasingrate",
              });

    const ariaLabel = intl.formatMessage(
        {
            id: "leaseme.priceInfo.ariaLabel",
            defaultMessage: "{ariaLabelFinanceType}: {price} pro Monat",
        },
        {
            ariaLabelFinanceType: ariaLabelFinanceType,
            price: formattedCurrencyText({
                intl,
                value: price,
            }),
        },
    );

    return (
        <sc.PriceInfoContainer aria-label={ariaLabel}>
            <sc.Price aria-hidden={true}>
                <FormattedCurrency value={price} />
            </sc.Price>
            <sc.Month isLowercase={scope.domain === "car4me.porschefinance.hu"} aria-hidden={true}>
                / <FormattedMessage id="leaseme.month.single" defaultMessage="Monat" />
            </sc.Month>

            <InfoIcon infoText={priceInfoText} alignment={alignment} />
        </sc.PriceInfoContainer>
    );
};

export default PriceInfo;
